const u = (() => {
  function getDateArray(start, end) {
    var arr = new Array(),
      dt = new Date(start);
    while (dt <= end) {
      arr.push(formatDate(new Date(dt)));
      dt.setDate(dt.getDate() + 1);
    }
    return arr;
  }

  function today() {
    return new Date();
  }
  // return 2021-06-25 from 2021-06-25T16:32:39.407 => summer/winter time errors
  function dstrip(str) {
    return str.replace(/T.+/gi, "");
  }

  // return yyyy-mm-dd
  function dateToIso(date) {
    return dstrip(date.toISOString());
  }
  // return iso date yyyy-mm-dd
  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [year, month, day].join("-");
  }
  // date / time ch format
  function renderDate(date) {
    var d = new Date(date);
    return d.toLocaleDateString("de-CH") + " " + d.toLocaleTimeString("de-CH");
  }
  // test if online or analog entries
  function testForOnline(str) {
    return str.toLowerCase().indexOf("online") > -1 ? true : false;
  }

  function getLicenceType(str) {
    return str.toLowerCase().indexOf("jugend") > -1 ? "young" : "adult";
  }

  function getlicenceDuration(str) {
    var test = str.toLowerCase();
    var value = "day";
    if (test.indexOf("woche") > -1) value = "week";
    if (test.indexOf("monat") > -1) value = "month";
    if (test.indexOf("jahr") > -1) {
      value = "year-small";
      if (test.indexOf("gross") > -1) value = "year-large";
    }
    return value;
  }

  // return product name
  function getLicenceName(data, productNr) {
    let obj = data.filter((o) => {
      return o.RelatedOrdersProductsID === productNr;
    });
    return obj.length ? obj[0].ProductName : productNr;
  }

  function getLicenceOwnerDetails(data, productNr) {
    let obj = data.filter((o) => {
      return o.RelatedOrdersProductsID === productNr;
    });
    console.log(obj);
    let out = null;
    if (obj.length) {
      let owner = obj[0];
      console.log("owner", owner);
      out = {
        name: owner.BillingLastName,
        firstname: owner.BillingFirstName,
        dob: owner["DOB"],
        guestcard: owner.guestcard,
        ordernumber: owner.RelatedOrderID,
      };
    }
    return out;
  }

  // limit calculations
  function checkTrout(array) {
    return array.filter((o) => {
      return o.TypeDisplayName.toLowerCase().indexOf("forelle") > -1;
    });
  }

  function dailyItemCount(array) {
    let t = dateToIso(today());
    return array.filter((o) => {
      return t == dateToIso(new Date(dstrip(o.AddedOn)));
    });
  }

  function checkRelatedProductItems(array, pnr) {
    return array.filter((o) => {
      return o.RelatedOrdersProductsID == pnr;
    });
  }

  function checkCisco(array) {
    return array.filter((o) => {
      return o.TypeDisplayName.toLowerCase().indexOf("felchen") > -1;
    });
  }

  // function dailyCiscoCount(array) {
  //   let t = dateToIso(today());
  //   return array.filter(o => {
  //     return t == dateToIso(new Date(dstrip(o.AddedOn)));
  //   });
  // }
  //
  // function checkRelatedProductCisco(array, pnr) {
  //   return array.filter(o => {
  //     return o.RelatedOrdersProductsID == pnr;
  //   });
  // }

  /*  getUrlParameter
          get parameter (name) of query string
      */
  function getUrlParameter(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    var results = regex.exec(location.search);
    return results === null
      ? ""
      : decodeURIComponent(results[1].replace(/\+/g, " "));
  }

  /*  updateQueryStringParameter
      update the query string with new value
  */
  function updateQueryStringParameter(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf("?") !== -1 ? "&" : "?";
    var out = uri + separator + key + "=" + value;
    if (uri.match(re)) {
      out = uri.replace(re, "$1" + key + "=" + value + "$2");
    }
    return out;
  }

  function updateQuerystring(uri) {
    let url = uri;
    let orderid = getUrlParameter("orderid");
    let userEmail = getUrlParameter("UserEmail");
    let guid = getUrlParameter("guid");
    if (orderid && userEmail && guid) {
      url = updateQueryStringParameter(
        updateQueryStringParameter(
          updateQueryStringParameter(url, "orderid", orderid),
          "UserEmail",
          userEmail
        ),
        "guid",
        guid
      );
    }
    return url;
  }

  return {
    today: today,
    dstrip: dstrip,
    dateToIso: dateToIso,
    formatDate: formatDate,
    renderDate: renderDate,
    testForOnline: testForOnline,
    getLicenceType: getLicenceType,
    checkTrout: checkTrout,
    checkCisco: checkCisco,
    dailyItemCount: dailyItemCount,
    getLicenceName: getLicenceName,
    checkRelatedProductItems: checkRelatedProductItems,
    getlicenceDuration: getlicenceDuration,
    getDateArray: getDateArray,
    updateQuerystring: updateQuerystring,
    updateQueryStringParameter: updateQueryStringParameter,
    getLicenceOwnerDetails: getLicenceOwnerDetails,
  };
})();

export default u;
